import './journeycard.css';
import JourneyScene from './JourneyScene';
import { journeyStats } from './journeysData';

function ArrowRightIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M5 12h13M13 6l6 6-6 6" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function JourneyCard({ journey, onClick }) {
  const { visited, total, pct } = journeyStats(journey);

  return (
    <button type="button" className="journeycard" onClick={onClick}>
      <div className="journeycard-top">
        <div className="journeycard-thumb">
          <JourneyScene theme={journey.theme} />
        </div>
        <div className="journeycard-info">
          <h4 className="journeycard-name">{journey.title}</h4>
          <p className="journeycard-desc">{journey.subtitle}</p>
        </div>
        <div className="journeycard-ring-wrap">
          <div className="journeycard-ring" style={{ '--pct': `${pct}%` }}>
            <span className="journeycard-ring-inner">
              {visited}/{total}
            </span>
          </div>
          <span className="journeycard-ring-label">Visited</span>
        </div>
      </div>

      <div className="journeycard-progress-row">
        <div className="journeycard-progress-track">
          <div className="journeycard-progress-fill" style={{ width: `${pct}%` }} />
        </div>
        <span className="journeycard-pct">{pct}%</span>
      </div>

      <span className="journeycard-arrow" aria-hidden="true">
        <ArrowRightIcon />
      </span>
    </button>
  );
}
